import http from './http';
import { API_PATHS } from '@/config/api';

class TestService {
  /**
   * Liste aller Tests abrufen
   * @returns {Promise} Promise mit der Antwort
   */
  getTests() {
    return http.get(API_PATHS.TESTS);
  }
  
  /**
   * Holt einen einzelnen Test
   */
  getTest(id) {
    return http.get(`/api/tests/${id}`);
  }
  
  /**
   * Neuen Test erstellen
   * @param {Object} data - Testdaten für die Erstellung
   * @returns {Promise} Promise mit der Antwort
   */
  createTest(data) {
    return http.post(API_PATHS.TESTS, data);
  }
  
  /**
   * Test bearbeiten
   * @param {number} id - Test-ID
   * @param {Object} data - Testdaten für die Aktualisierung
   * @returns {Promise} Promise mit der Antwort
   */
  updateTest(id, data) {
    return http.put(`${API_PATHS.TESTS}/${id}`, data);
  }
  
  /**
   * Löscht einen Test
   */
  deleteTest(id) {
    return http.delete(`/api/tests/${id}`);
  }
  
  /**
   * Anzahl der Fragen abrufen
   * @returns {Promise} Promise mit der Antwort
   */
  getQuestionCount() {
    return http.get(API_PATHS.TESTS_QUESTION_COUNT);
  }
}

export default new TestService(); 